import React from "react";
import { Route, Routes, Outlet, Navigate } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import useSession from "../hooks/useSession";

import Login from "../utils/Login";
import Callback from "../utils/Callback";
import Layout from "../pages/Layouts/Layout";
import Analytics from "../pages/Analytics/Analytics";
import Members from "../pages/Members/Members";
import TaskHome from "../pages/Task/TaskHome";
import TaskEdit from "../pages/Task/TaskEdit";
import TriviaQuestion from "../pages/TriviaQuestion";
import ManageTenant from "../pages/Tenant/ManageTenant";
import ExportTenant from "../pages/Tenant/ExportTenant";
import ProvisionNewTenant from "../pages/Tenant/ProvisionNewTenant";
import ReportRouter from "../pages/Analytics/ReportRouter";
import Unauthorized from "../utils/Unauthorized";

const FullScreenLoader = () => (
  <Box
    sx={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress />
  </Box>
);

export default function AppRoutes() {
  const { isLoggedIn, isLoading } = useSession();

  const Protected = () => {
    if (isLoading) return <FullScreenLoader />;
    return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
  };

  const UnProtected = () => {
    if (isLoading) return <FullScreenLoader />;
    return isLoggedIn ? <Navigate to="/analytics" replace /> : <Outlet />;
  };

  return (
    <Routes>
      {/* Public / auth pages */}
      <Route element={<UnProtected />}>
        <Route path="/" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
      </Route>

      {/* Protected app */}
      <Route element={<Protected />}>
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/analytics/*" element={<Layout />}>
          <Route index element={<Analytics />} />
          <Route path="reports/:reportPath" element={<ReportRouter />} />
          <Route path="members" element={<Members />} />

          {/* <Route path="customizations">
            <Route path="task-actions" element={<TaskHome />} />
            <Route path="task-actions/edit/*" element={<TaskEdit />} />
            <Route path="trivia-question" element={<TriviaQuestion />} />
          </Route>

          <Route path="tenant">
            <Route path="manage-tenant" element={<ManageTenant />} />
            <Route path="export-tenant" element={<ExportTenant />} />
            <Route path="provision-tenant" element={<ProvisionNewTenant />} />
          </Route> */}
        </Route>
      </Route>
    </Routes>
  );
}
